
export default {
    head() {
        return {
            title: this.pageData.metatitle ? this.pageData.metatitle : this.pageData.h1,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.pageData.metadesc,
                },
            ],
        }
    },

    data() {
        return {
            pageData: null,
        };
    },

    asyncData(context) {
        return context.$axios
            .get('/help')
            .then((res) => {
                return {
                    pageData: res.data,

                }
            })

    },
}
